// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"f4e43491","administration":"4b0a5bcf"}[chunkId] + ".chunk.js";
};